import tw, { styled } from 'twin.macro'

const Tag = styled.span([
  tw`inline-flex items-center px-2 py-0.5 rounded text-xs`,
  tw`text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-800`,
])

export default Tag
